import React from 'react';

import { ModalTrigger } from '../../ui';
import ManagedModal from '../../ui/ManagedModal';

import CelebrationModalContainer, { CelebrationModalContainerProps } from './CelebrationModalContainer';

const open = (props: Partial<CelebrationModalContainerProps>) => {
  const modal = new ManagedModal({
    triggerType: ModalTrigger,
    renderModal: close => (
      React.createElement(CelebrationModalContainer, {
        ...props,
        close,
      })
    ),
  });

  modal.open();

  return modal;
};

export {
  open,
};
